<div class="sub-base">
    <div class="body">
        <div class="image" [style.backgroundImage]="image"></div>
        <div class="title">
            {{ community?.name }}
        </div>
    </div>
</div>